<template>
  <div>
    <div>
      <!-- <p style="color: #9e9c9b; font-size: 13px; margin-top: -10px; margin-left: 2px">PUBLIC SALES ARE LIVE</p>
      <p style="font-size: 36px; margin-top: 5px"><span style="color: #cd4743">Tron</span> IVY BOYS</p> -->
    </div>

    <div class="mint-box" v-if="!isSoldOut">
      <div class="center" style="margin: 5px 0 10px 0">
        <img src="@/assets/pc/tron.png" style="width: 44px; margin-right: 13px" />
        <img src="@/assets/pc/100.png" style="width: 88px; margin-right: 5px" />
        <img src="@/assets/pc/trx.png" style="width: 41px; margin-right: 10px" />
      </div>
      <!-- total available -->
      <!-- <div style="height: 80px; padding-top: 10px">
        <p style="font-size: 17px">
          Total Available:
          <span v-if="!isConnected">Connect your wallet to see</span>
          <span v-else>{{ max }}</span>
        </p>
        <p style="font-size: 12px; font-style: italic; margin-top: 5px; margin-bottom: 20px">
          Price per unit: 100TRX + Gas Fee
        </p>
      </div> -->
      <!-- num-select -->
      <div class="mint-select center">
        <div class="edit-icon center" :class="{ disabled: minusDisabled }" @click="minusMintNum">&#8722;</div>
        <input
          class="edit-input"
          v-model.number="mintNum"
          @keypress="onlyNumber($event)"
          @blur="onBlur"
          :disabled="true"
        />
        <div class="edit-icon center" :class="{ disabled: addDisabled }" @click="addMintNum">&#43;</div>
      </div>
      <!-- confirm -->
      <div>
        <div class="mint-confirm center" v-if="!isConnected && !isConnecting" @click="connectWallet">
          <img style="width: 140px" src="@/assets/pc/11connect.png" />
        </div>
        <div class="mint-confirm center disabled" v-else-if="isConnecting">
          <img style="width: 108px" src="@/assets/pc/coning.png" />
        </div>
        <div class="mint-confirm center" :class="{ disabled: !canMint }" v-else-if="!isMinting" @click="triggerMint">
          <img style="width: 44px" src="@/assets/pc/mint.png" />
        </div>
        <div class="mint-confirm center disabled" v-else>
          <img style="width: 87px" src="@/assets/pc/minting.png" />
        </div>
      </div>
    </div>

    <a class="mint-box-soldout" v-else href="https://testnet.apenft.io/collections/TPieceOfShit">
      <p style="font-size: 40px; font-weight: bold">SOLD OUT</p>
      <!-- <p style="font-size: 14px; font-weight: bold; margin-top: 5px">BUY ON APENET</p> -->
      <!-- <img src="@/assets/pc/sold-out-icon.png" id="soldout-icon" /> -->
      <div class="mint-confirm center" id="soldout-icon">BUY ON APENET</div>
    </a>
  </div>
</template>
<script>
import { walletMixin } from '../mixin.js';
export default {
  name: 'stage23',
  mixins: [walletMixin],
  props: {
    countdownArr: [],
    stage: Number,
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.countdown-box {
  width: 39px;
  height: 29px;
  background: #cd4743;
  border-radius: 3px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.countdown-divider {
  color: #cd4743;
  margin: 0 5px;
}
.mint-box {
  background-color: #daaa64;
  border: 5px solid #a48261;
  text-align: center;
  color: #000;
  width: 285px;
  height: 300px;
  padding: 16px 16px;
  margin-top: 20px;
}
.mint-box-soldout {
  background-color: #daaa64;
  border: 5px solid #a48261;
  text-align: center;
  color: #fff;
  width: 240px;
  margin-top: 20px;
  display: block;
  padding: 40px 0 60px 0;
  position: relative;
  height: 180px;
  #soldout-icon {
    // width: 60px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.mint-select {
  width: 140px;
  height: 64px;
  margin: 41px auto 47px auto;
  background-color: #fff;
  justify-content: space-around;
  padding: 0 15px;
  .edit-icon {
    width: 18px;
    height: 18px;
    // background-color: #cd4743;
    font-size: 24px;
    border-radius: 100%;
    color: #000;
    cursor: pointer;
    padding-bottom: 3px;
    font-weight: lighter;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  .edit-input {
    font-size: 40px;
    font-family: 'Helvetica', 'Arial', sans-serif;
    font-weight: bold;
    color: #000;
    width: 42px;
    text-align: center;
  }
}
.mint-confirm {
  width: 198px;
  height: 47px;
  background: url('~@/assets/pc/11back.png') no-repeat;
  background-size: contain;
  padding-bottom: 5px;
  // background-color: #cd4743;
  color: #fff;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 2px;
  font-size: 12px;
  &.disabled {
    opacity: 0.5;
  }
}
</style>
